
import React from "react";
import { Card } from "@/components/ui/card";
import MapboxMap from "./MapboxMap";
import { Terrace } from "@/types/terrace";

type TerraceMapProps = {
  terraces: Terrace[];
  userLocation?: { lat: number; lng: number } | null;
};

const TerraceMap: React.FC<TerraceMapProps> = ({ terraces, userLocation }) => {
  return (
    <Card className="w-full h-[60vh] overflow-hidden relative border-peach-orange/20">
      <MapboxMap terraces={terraces} userLocation={userLocation} />
    </Card>
  );
};

export default TerraceMap;
